import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {LastMatchesLayoutDataColumnApiModel} from "./game-h2h.competitor.layout-data.column.api-model";

export class LastMatchesLayoutDataColumnDomainModel extends BaseDomainModel{
  num: Number;
  title: String;

  constructor(model: LastMatchesLayoutDataColumnApiModel) {
    super(model);

    this.num = model.num;
    this.title = model.title;
  }
}